// src/features/auth/components/AuthGuard.jsx
import React from 'react';
import { useAuth } from '../../../context/AuthContext';
import { Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LoadingScreen from '../../../components/common/LoadingScreen';

const useLocation = () => ({ pathname: '/home' });

export default function AuthGuard({ children }) {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();
  const { t } = useTranslation("auth");

  if (isLoading) {
    return <LoadingScreen text={t("auth:loading.authenticating")} />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}